import React, { Component } from 'react'
import Typography from '@material-ui/core/Typography'
import Link from '@material-ui/core/Link'
import Button from '@material-ui/core/Button'
import { withRouter } from 'react-router-dom'

class OrderNotFound extends Component {
  render() {
    return (
      <div>
        <Typography variant="h6" component="div">Order Not Found.</Typography>
        <p>Whoops! We're having trouble locating your order. Please double check your order number, which can be found on your packing slip or in the shipping confirmation email. The number will follow one of these formats: SO123456 OR 7000123456 OR 111-123456-123456. Please also confirm you're entering your shipping zip code. Click "Try Again" below to re-enter your information.</p>
        <p>Still having trouble? Contact us at <Link url="mailto://support@braceability.com">support@braceability.com</Link> or <Link url="tel://866-712-7808">866-712-7808</Link></p>
        <Button color="primary" variant="contained" onClick={() => this.props.history.replace('/pages/' + this.props.pageName)} >Try Again</Button>
      </div>
    )
  }
}

export default withRouter(OrderNotFound)
